export const conversation = {
    from: {
        timelineItem(item) {
            return {
                message_delivery_status: null,
                initial_channel: item.channel,
                direction: item.direction,
                is_abandoned: null,
                is_callback_consumed: false,
                is_closed: item.is_closed,
                last_message_created_at: null,
                queued_at: null,
                status: item.status,
                id: item.id,
            };
        },
    },
};
export const metaConversation = {
    from: {
        conversation(conversation, requester) {
            return {
                conversation,
                requester,
                callersOnHold: [],
                extraParties: {},
                integrations: [],
                isAssignedToMe: false,
                linkedConversations: [],
                messages: [],
                tempMessage: '',
                tempWrapup: '',
                unread: 0,
            };
        },
        timelineItem(item, requester) {
            return {
                conversation: conversation.from.timelineItem(item),
                requester,
                callersOnHold: [],
                extraParties: {},
                integrations: [],
                isAssignedToMe: false,
                linkedConversations: [],
                messages: [],
                tempMessage: '',
                tempWrapup: '',
                unread: 0,
            };
        },
    },
};
